import * as Yup from 'yup';

const DeviceSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    serial_number: Yup.string().required(t('general_errors.required')),
    device_uuid: Yup.string().required(t('general_errors.required')),
    name: Yup.string(),
    device_type: Yup.string().nullable(),
    description: Yup.string(),
    remote_id_number: Yup.string(),
    faa_reg_number: Yup.string()
  });

export default DeviceSchema;
